module.exports = __webpack_public_path__ + "images/emoji/grey_question.b53f477e3d41e430d8cc.png";